import React, { useEffect, useState } from "react";
import { IonContent, IonPage } from "@ionic/react";
import useAPI from "../../hooks/basic/useAPI";
import MatchStatistics from "../../components/MatchStatistics/MatchStatistics";

const MatchStatisticsPage = ({ match }) => {
  const matchId = match.params.matchId;
  const { callAPI } = useAPI();
  const [matchStatistics, setMatchStatistics] = useState(null);

  const getStatistics = async () => {
    try {
      const matchStatisticsResult = await callAPI({
        url: `/match-statistics`,
        method: "GET",
        params: {
          id: matchId,
        },
      });
      setMatchStatistics(matchStatisticsResult);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getStatistics();
  }, []);

  if (!matchStatistics) {
    return null;
  }



  return (
    <IonPage>
      <IonContent id="match-page">
        <MatchStatistics data={matchStatistics} />
      </IonContent>
    </IonPage>
  );
};

export default MatchStatisticsPage;
